// extracted by mini-css-extract-plugin
export default {"container":"services_container__1eSE0","h1":"services_h1__6-z1U","p":"services_p__Vg7DF","cardBox":"services_cardBox__zWDm-"};